module.exports = __webpack_public_path__ + "static/img/stardust.c7be0cf6.svg";